module.exports = __webpack_public_path__ + "img/su-dashboard.8b50bf4a.png";